import { render, staticRenderFns } from "./position_info.vue?vue&type=template&id=4b65ca29&scoped=true"
import script from "./position_info.vue?vue&type=script&lang=js"
export * from "./position_info.vue?vue&type=script&lang=js"
import style0 from "./position_info.vue?vue&type=style&index=0&id=4b65ca29&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65ca29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b65ca29')) {
      api.createRecord('4b65ca29', component.options)
    } else {
      api.reload('4b65ca29', component.options)
    }
    module.hot.accept("./position_info.vue?vue&type=template&id=4b65ca29&scoped=true", function () {
      api.rerender('4b65ca29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/add_user/components/position_info/position_info.vue"
export default component.exports